export default {
  integration: {
    map_no_open:'The map feature is not yet available. Coming soon…',
    see_line_data:'Click to view the historical chart.',
    alarm_or_not: 'Alarm or Not',
    mount_: 'mount ',
    success: 'Send Successful',
    'Online': 'Online',
    'on-line': 'Online',
    'off-line': 'Offline',
    stop_it: 'Disable',
    normal_reporting_data: 'Normal Reporting Data',
    not_in_flight_mode: 'Airplane Mode Off',
    flight_mode: 'Airplane Mode',
    gateway_name_: 'Gateway Name ',
    gateway_nickname: 'Nickname',
    battery_supply: 'Battery Powered',
    gateway_heartbeat_history: 'Gateway Heartbeat Records',
    abnormal_sensor_connection: 'Sensor Connection Abnormal',
    abnormal_sensor_temperature: 'Sensor Temperature Abnormal',
    abnormal_sensor_humidity: 'Sensor Humidity Abnormal',
    gateway_connection_exception: 'Gateway Connection Abnormal',
    gateway_power_failure_exception: 'Gateway Power Outage Abnormal',
    abnormal_connection_of_display_screen:
      'Display Connection Abnormal',
    abnormal_relay_connection: 'Repeater Connection Abnormal',
    handle: 'Handle',
    handle_event: 'Handle Event',
    return_processing: 'Returned for Handling',
    processed_successfully: 'Handling Successful',
    parameter_error: 'Parameter Error',
    the_corresponding_reason_cannot_be_found:
      'Causes not found.',
    associated_device_not_found: 'Associated device not found.',
    illegal_handler: 'Invalid Handler',
    exception_record_not_found: 'Abnormal record not found.',
    illegal_description: 'Invalid Description',
    processing_time_: 'Processing Time',
    trunk_number: 'Repeater ID',
    relay_nickname: 'Repeater Nickname',
    relay_type: 'Repeater Type',
    update_time: 'Update Time',
    sensor_number: 'Sensor ID',
    sensor_type: 'Sensor Type',
    sensor_status: 'Sensor Status',
    acquisition_interval: 'Sampling Interval',
    abnormal_collection_interval: 'Abnormal Sampling Interval(s)',
    temperature_acquisition_interval: 'Temp Sampling(s)',
    temperature_change_threshold: 'Temp Change Threshold',
    maximum_temperature_reporting_interval:
      'Max Temp Report(s)',
    minimum_temperature_reporting_interval:
      'Min Temp Report(s)',
    humidity_collection_interval: 'RH Sampling(s)',
    humidity_change_threshold: 'RH Change Threshold',
    maximum_humidity_reporting_interval: 'Max RH Report(s)',
    humidity_minimum_reporting_interval: 'Min RH Report(s)',
    text: 'Text',
    switch_to_line_chart: 'Switch to Line Chart',
    switch_to_histogram: 'Switch to Bar Chart',
    picture_download: 'Picture Download',
    line_chart: 'Line Chart',
    switch_language_successfully: 'Language Switch Successful',
    tips: 'Tips',
    add_exception_reason_definition: 'Add Cause',
    the_last_piece_of_data_cannot_be_deleted:
      'Last record cannot be deleted.',
    reason_cannot_be_empty: 'The causes are required.',
    fail: 'Failed',
    name_already_exists: 'Name already exists.',
    data_error: 'Data Error',
    refrigerator: 'Refrigerator',
    vehicle: 'Vehicle',
    cold_storage: 'Cold Storage',
    retention_exception: 'Retain Exception',
    no_more: 'No More',
    load_more: 'Load More',
    scroll_to_the_bottom_to_load_more: 'Scroll to the bottom for more items.',
    name_cannot_be_empty: 'Name is required.',
    code_cannot_be_empty: 'ID/SN is required.',
    code_already_exists: 'ID/SN already exists.',
    the_added_node_type_is_incorrect: 'The node type added is incorrect.',
    failed_to_add: 'Add Failed',
    update_successful: 'Update Successful',
    update_failed: 'Update Failed',
    the_longitude_entered_is_illegal: 'Invalid Longitude Entered',
    the_latitude_entered_is_illegal: 'Invalid Latitude',
    longitude_cannot_be_empty: 'Longitude is required.',
    latitude_cannot_be_empty: 'Latitude is required.',
    successful_positioning: 'Positioning Successful',
    upload_successful: 'Upload Successful',
    abnormal: 'Abnormal',
    normal: 'Normal',
    no_temperature_monitoring_section: 'No temperature monitoring range.',
    humidity_free_monitoring_section: 'Unassociated RH Range',
    select_at_least_one_mount_to_remove: 'Please select at least one sensor point to remove.',
    deleting_fixed_points_needs_to_be_done_in_edit_mode: 'Marked Point Deletion is only allowed in edit mode.',
    successfully_deleted: 'Deletion Successful',
    there_are_no_removable_mounting_anchors:
      'No removable sensor point markers.',
    position_cannot_be_empty: 'Location is required.',
    carrier_cannot_be_empty: 'Asset is required.',
    add_to: 'New',
    only_peer_nodes_are_allowed_to_drag: 'Drag and drop only allowed between sibling nodes.',
    drag_succeeded: 'Drag Successful',
    new_contact_information: 'New Contact Method',
    synchronization_failed: 'Sync Failed',
    synchronization_successful: 'Sync Successful',
    customer_cannot_be_empty: 'Company is required.',
    mobile_number_cannot_be_empty: 'Mobile number is required.',
    mailbox_cannot_be_empty: 'Email is required.',
    please_enter_the_correct_email_address:
      'Please enter a valid Email address.',
    mobile_number_already_exists: 'Mobile number already exists.',
    mailbox_already_exists: 'Email already exists.',
    monitoring_interval_already_exists: 'Monitoring Range already exists.',
    system_error: 'System Error',
    name: 'Instance Name',
    export_type: 'Export Type',
    state: 'Status',
    select_at_least_one_piece_of_data: 'Please select at least one data record.',
    delete_failed: 'Deletion Failed',
    download_failed: 'Download Failed',
    the_file_does_not_exist: 'The file does not exist.',
    the_file_has_been_deleted: 'The file has been deleted.',
    zhang_san: 'Zhang San',
    task_cannot_be_empty: 'Task is required.',
    interval_cannot_be_empty: 'Interval is required.',
    hour: 'Hour',
    day: 'Days',
    task_content_cannot_be_empty: 'Task content is required.',
    execution_interval_cannot_be_empty: 'Execution interval is required.',
    task_failed: 'Task Failed',
    running: 'Running',
    new_task: 'New Task',
    'are_you_sure_about_this_operation?': 'Please confirm this operation.',
    trigger: 'Trigger',
    data_cannot_be_empty: 'Data is required.',
    every_day: 'Every Day',
    the_first_day_of_each_week: 'The first day of week.',
    last_day_of_the_week: 'Last day of week',
    the_first_day_of_each_month: 'The first day of month.',
    last_day_of_each_month: 'Last day of month',
    first_day_of_each_quarter: 'First Day of Quarter',
    last_day_of_each_quarter: 'Last day of quarter',
    the_first_day_of_each_year: 'The first day of year.',
    last_day_of_each_year: 'Last day of year',
    print_every_two_minutes: 'Print Every Two Minutes',
    newly_added: 'New',
    keep_at_least_one_acquisition_time: 'Keep at least one sampling time.',
    keep_at_least_one_print_setting_time:
      'Keep at least one print setting time.',
    printer_collection: 'Printer Collection',
    keep_at_least_one_printer: 'Keep at least one printer.',
    please_select_at_least_one_print_group_information:
      'Please select at least one print group.',
    please_select_at_least_one_sensor_data:
      'Please select at least one sensor data record.',
    the_selected_data_has_sensorless_correlation:
      'Selected data includes items with no sensor association.',
    please_select_at_least_one_printer: 'Please select at least one printer.',
    time_selection_has_empty_time: 'Time selection contains empty time.',
    contact_cannot_be_empty: 'Contact person is required.',
    phone_number_cannot_be_empty: 'Phone is required.',
    please_enter_email_address: 'Please enter Email address',
    level_name_cannot_be_empty: 'Level name is required.',
    keep_at_least_one: 'Keep at least one item.',
    please_enter_an_integer: 'Please enter an integer.',
    select_at_least_one_day_of_alarm_time:
      'Please select at least one alarm day.',
    fill_at_least_one_time_point_for_each_item:
      'Please enter at least one time point for each item.',
    trigger_name_cannot_be_empty: 'Trigger name is required.',
    range_cannot_be_empty: 'Range is required.',
    check_at_least_one_item: 'Check at least one item',
    repetition_times_cannot_be_empty: 'Repeat count is required.',
    repetition_interval_cannot_be_empty: 'Repeat interval is required.',
    up_to_seven_record_times: 'Up to 7 record times.',
    keep_at_least_one_piece_of_data: 'At least one record is required.',
    the_same_time_point_cannot_exist: 'No duplicate time points allowed.',
    keep_at_least_one_point_in_time: 'Keep at least one time point.',
    approved_successfully: 'Approval Successful',
    voice: 'Voice',
    short_message: 'SMS',
    mail: 'Email',
    no_forwarding: 'No Forwarding',
    three_times_smaller: 'Zoom Out 3x',
    shrink_twice: 'Zoom Out 2x',
    original_proportion: 'Original Scale',
    zoom_in_twice: 'Zoom In 2x',
    zoom_in_three_times: 'Zoom In 3x',
    please_select_the_device_to_be_located:
      'Please select the device to locate.',
    saved_successfully: 'Save Successful',
    collection_unit_cannot_be_empty: 'Measurement Unit is required.',
    record_point_cannot_be_empty: 'Record Point is required.',
    set_successfully: 'Setting Successful',
    'are_you_sure_to_close_the_acquisition_record_point?':
      'Please confirm to disable the record point.',
    closed_successfully: 'Close Successful',
    collection_record_is_not_opened: 'Readings recording not enabled.',
    record_point: 'Record Point',
    record_time: 'Record Time',
    person_in_charge: 'Person in Charge',
    autograph: 'Use E-signature?',
    alarm_trigger_setting: 'Alarm Trigger Settings',
    selection_area_provides_data: 'Select area to provide data.',
    need_to_deal_with: 'Needs Handling',
    edit_mode: 'Edit Mode',
    chinese_comma_and_center_line_cannot_be_entered:
      'Cannot input Chinese commas or dashes.',
    mount_status_cannot_be_empty: 'Sensor point status is required.',
    mount_name_cannot_be_empty: 'Sensor point name is required.',
    record_date: 'Record Date',
    approval_time: 'Approval Time',
    approval: 'Approve',
    approver: 'Approver',
    export: 'Export File',
    approved: 'Approved',
    approval_rejected: 'Rejected',
    not_approved: 'Not Approved',
    the_selected_data_has_approved_data: 'Selected data includes approved records.',
    please_select_the_same_mounting_data_for_approval:
      'Please select the same sensor point data for approval.',
    please_select_the_same_time_record_point_data:
      'Please select the same time record point data.',
    the_same_mount_name_exists: 'The sensor point name already exists.',
    the_range_of_the_user_is_inconsistent_with_the_current_page_range:
      'The user\'s scope does not match the current page scope.',
    save_failed: 'Save Failed',
    behavior: 'Operation Type',
    operator: 'Operator',
    data: 'Data',
    abnormal_record: 'Abnormal Records',
    mount_information: 'Asset Information',
    to_update: 'Update',
    alarm_settings: 'Alarm Trigger',
    cancel_device: 'Cancel Device',
    mount_auxiliary_settings: 'Asset Auxiliary Settings',
    handling_exceptions: 'Handling Abnormal',
    delete_exception: 'Delete Abnormal Records',
    set_recording_point: 'Set Record Point',
    close_record_point: 'Close Record Point',
    update_mount: 'Update Asset',
    delete_mount: 'Delete Asset',
    set_alarm: 'Set Alarm',
    no_parameter_data: 'No parameter data.',
    add_mount: 'New Asset',
    belonging_to: 'Associated',
    name_of_monitoring_point: 'Asset Details',
    type: 'Type',
    role_type: 'Role Type',
    traceable: 'Traceable',
    alarm_on: 'Alarm On',
    label: 'Tag',
    describe: 'Description',
    yes: 'Confirm',
    no: 'No',
    please_select_at_least_one_data: 'Please select at least one record.',
    time_cannot_be_empty: 'Time is required.',
    temperature: 'Temperature',
    real_time_data_collection: 'Real-time Reading',
    store_collected_data: 'Stored Readings',
    check_at_least_one_architecture_point:
      'Please select at least one organization node.',
    type_cannot_be_empty: 'Type is required.',
    last_week: 'Last 7 Days',
    last_month: 'Last Month',
    last_three_months: 'Last 3 Months',
    guangzhou_disease_control: 'Guangzhou CDC',
    pop_up_button: 'Pop-up Button',
    equipment_details: 'Device Details',
    historical_line_chart: 'Historical Curve',
    whether_to_start_heartbeat: 'Enable heartbeat?',
    gateway_type_: 'Gateway Type ',
    display_status: 'Display Status',
    relay_status: 'Repeater Status',
    first_case: 'First Case',
    offline_duration: 'Offline Duration',
    offline_times: 'Offline Count',
    second: 's',
    configuration_success_times: 'Configuration Success Count',
    configuration_times: 'Configuration Count',
    duration_of_power_failure: 'Power Outage Duration',
    outage_times: 'Power Outage Count',
    offline_analysis: 'Offline Analysis',
    configuration_analysis: 'Configuration Analysis',
    outage_analysis: 'Power Outage Analysis',
    data_analysis_settings: 'Data Analysis Settings',
    data_board: 'Instance View',
    refresh_content: 'Auto Refresh Time',
    real_time_situation: 'Real-time Status',
    data_analysis: 'Data Analysis',
    check_at_least_one_item_of_data: 'Please select at least one item.',
    no_data_temporarily: 'No Data Available',
    please_view_first: 'Please select the device to view first.',
    fixed_test_point: 'Fixed Test Point',
    move_test_point: 'Mobile Test Point',
    click_to_see_more: 'Click to View More',
    start_date_cannot_be_later_than_end_date:
      'Start date cannot be later than end date.',
    the_left_section_cannot_be_greater_than_the_right_section:
      'Left range cannot be greater than right range.',
    display: 'Show Label',
    abnormal_duration: 'Abnormal Duration',
    number_of_exceptions: 'Abnormal Count',
    alarm_trigger_times: 'Alarm Trigger Times',
    times: 'times',
    normal_abnormal_proportion: 'Normal/Abnormal Ratio',
    monitoring_point_status: 'Asset Status',
    monitoring_point_type: 'Type',
    pause_alarm: 'Pause Alarm',
    only_numbers_can_be_entered: 'Please enter a numeric value with no more than two decimal places.',
    display_type_cannot_be_empty: 'Display type is required.',
    time_zone_cannot_be_empty: 'Time Zone is required.',
    the_display_name_cannot_be_empty: 'Display name is required.',
    screen_nickname_cannot_be_empty: 'Display nickname is required.',
    the_display_number_cannot_be_empty: 'Display ID is required.',
    duration_cannot_be_empty: 'Duration is required.',
    initialization_command: 'Init Command',
    modify_configuration: 'Update Configuration',
    some_commands_are_configured: 'Some commands have already been configured.',
    configuration_successful: 'Configuration Successful',
    configuration_steps: 'Configuration Steps',
    detection_interval: 'Detection Interval',
    rule_escalation: 'Rule Reporting',
    modify_customer: 'Edit Company',
    are_you_configuring: 'Configuring?',
    display_creation_time: 'Display Creation Time',
    display_deactivation_time: 'Display Deactivation Time',
    the_selected_display_screen_is_not_the_same_customer:
      'Selected displays are not from the same customer.',
    new_display: 'New Display',
    the_selected_sensor_is_not_the_same_customer:
      'Selected sensors are not from the same customer.',
    gateway_type_cannot_be_empty: 'Gateway type is required.',
    gateway_serial_number_cannot_be_empty:
      'Gateway SN is required.',
    gateway_nickname_cannot_be_empty: 'Gateway Nickname is required.',
    channel_mask_cannot_be_empty: 'Channel Mask is required.',
    gateway_deactivation_time: 'Gateway Deactivation Time',
    the_selected_gateway_is_not_the_same_customer:
      'Selected gateways are not from the same customer.',
    form_template: 'Form Template',
    new_gateway: 'New Gateway',
    edit_gateway: 'Edit Gateway[{mac}]',
    download_successful: 'Download Successful',
    relay_type_cannot_be_empty: 'Repeater Type is required.',
    relay_number_cannot_be_empty: 'Repeater ID is required.',
    relay_nickname_cannot_be_empty: 'Repeater Nickname is required.',
    relay_name: 'Repeater Name',
    relay_creation_time: 'Repeater Created Time',
    add_relay: 'New Repeater',
    sensor_deactivation_time: 'Sensor Deactivation Time',
    voltage: 'Voltage',
    forwarding_gateway_name: 'Forwarding Gateway Name',
    normal_acquisition_interval: 'Normal Sampling Interval',
    the_selected_sensor_has_a_disabled_status:
      'Selected sensor is deactivated.',
    please_select_the_same_temperature_or_temperature_humidity_sensor:
      'Please select the same temperature or temp/humidity sensor.',
    minimum_temperature: 'Min. Temperature',
    maximum_temperature: 'Max. Temperature',
    minimum_humidity: 'Min. RH',
    maximum_humidity: 'Max. RH',
    configuration_completed: 'Configuration Completed',
    overtime: 'Overtime',
    number_cannot_be_empty: 'ID/SN is required',
    new_sensor: 'New Sensor',
    storage: 'Storage',
    humidity: 'Relative Humidity',
    successfully_modified: 'Update Successful',
    please_input_a_password: 'Please enter password.',
    please_enter_the_password_again: 'Please enter password again.',
    old_password_cannot_be_empty: 'Old Password is required.',
    the_new_password_cannot_be_empty: 'The New Password is required.',
    confirmation_cannot_be_empty: 'Confirmation is required.',
    userInformation_not_found: 'User information not found',
    the_old_password_is_incorrect: 'The old password is incorrect',
    agent_management: 'Agent Admin',
    customer_use: 'Company User',
    customer_management: 'Company Admin',
    platform_usage: 'Platform User',
    platform_management: 'Platform Admin',
    male: 'Male',
    female: 'Female',
    unknown: 'Unknown',
    user_name_cannot_be_empty: 'User name is required.',
    email_address_cannot_be_empty: 'Email address is required.',
    boot_function: 'Guidance',
    view_accessible_operation_resources: 'View Resources',
    electronic_signature_: 'Electronic Signature',
    change_password: 'Change Password',
    unit_setting: 'Unit Setting',
    user_name_already_exists: 'User name already exists.',
    email_address_is_required_and_must_conform_to_the_email_format:
      'Email address is required and must conform to the email format',
    mobile_number_is_required_and_must_conform_to_the_format_of_mobile_number:
      'Mobile number is required and must be in a valid phone number format.',
    email_address_already_exists: 'Email already exists.',
    'are_you_sure_to_turn_boot_on_or_off?':
      'Please confirm to enable or disable the guide.',
    resources: 'Resources',
    map_architecture: 'Map Architecture',
    current_schema_not_found_on_map: 'Current organization node not found on the map.',
    custom_event_name: 'Custom Event Name',
    incorrect_verification_code_input: 'Incorrect Verification Code',
    sign_in: 'Login',
    login_successful: 'Login Successful',
    plan: 'Floor Plan',
    'real-time_data_': 'Real-time Data',
    page_not_found: 'Page Not Found',
    the_specified_time_cannot_be_empty: 'Specified time is required.',
    record_point_setting: 'Record Point Setting',
    setting_failed: 'Setting Failed',
    data_already_exists: 'Data already exists',
    record_point_time_repetition: 'Duplicate Record Point Time.',
    record_points_cannot_be_repeated: 'Record points cannot be duplicated.',
    mount_type_details: 'Asset Type Details',
    edit_mount_type: 'Edit Asset Type',
    select_at_least_one_application_object:
      'Please select at least one application target.',
    new_mount_type: 'New Asset Type',
    enable_status_cannot_be_deleted: 'Cannot  be deleted while enabled.',
    only_positive_integers_are_allowed: 'Only positive integers allowed.',
    length_cannot_be_empty: 'Length is required.',
    logout_successful: 'Deactivation Successful',
    activation_successful: 'Activation Successful',
    customer_name_cannot_be_empty: 'Company name is required',
    customer_code_cannot_be_empty: 'Company ID is required.',
    customer_status_cannot_be_empty: 'Company status is required.',
    contact_information_cannot_be_empty: 'Contact information is required.',
    customer_type_cannot_be_empty: 'Company type is required.',
    the_same_customer_name_already_exists:
      'Company name already exists.',
    the_same_customer_code_already_exists:
      'Company ID already exists.',
    the_same_email_already_exists: 'Email already exists.',
    the_same_mobile_number_already_exists:
      'Mobile number already exists.',
    email_format_error: 'Invalid email address format.',
    runhui_science_park: 'Runhui Science Park',
    keep_at_least_one_data: 'Keep at least one data  records.',
    uom_already_exists: 'Measurement Unit already exists.',
    unit_tag_already_exists: 'Unit Mark already exists.',
    unit_number_already_exists: 'Unit ID already exists.',
    function_code_cannot_be_empty: 'Function Code is required.',
    function_cannot_be_empty: 'Function is required.',
    activation: 'Enable',
    cancellation: 'Deactivate',
    mount_type_icon: 'Asset Type Icon',
    exception_category_icon: 'Abnormal Type Icon',
    end_date_cannot_be_earlier_than_start_date:
      'End date cannot be earlier than start date.',
    please_enter_the_start_date: 'Please enter the start date.',
    please_select_data: 'Please select data.',
    please_select_a_file: 'Please select a file.',
    statistics: 'Statistics',
    year_on_year: 'Year on year ',
    month_on_month: 'Month on month ',
    year: 'year',
    month: 'month',
    anomaly_analysis: 'Abnormal Analysis',
    alarm_trigger_analysis: 'Alarm Trigger Analysis',
    normal_and_abnormal_proportion_analysis:
      'Normal vs Abnormal Ratio Analysis',
    proportion: 'Scale',
    closed_connection_exception_alarm: 'Connection abnormal alarm has been closed.',
    connection_exception_alarm_started: 'Connection Abnormal Alarm Enable',
    power_off_abnormal_alarm_has_been_turned_off:
      'Power Outage Alarm Disabled',
    power_failure_abnormal_alarm_has_been_started:
      'Power Outage Alarm Enabled',
    data_abnormal_alarm_has_been_turned_off:
      'Data abnormal alarm disabled.',
    data_abnormal_alarm_started: 'Data abnormal alarm enabled',
    mail_notification_turned_off: 'Mail Notification Disabled',
    mail_notification_started: 'Mail Notification Enable',
    sms_notification_has_been_turned_off:
      'SMS Notification Disabled',
    sms_notification_started: 'SMS notification Enabled',
    voice_notification_turned_off: 'Voice Notification Disabled',
    voice_notification_started: 'Voice Notification Enabled',
    display_type_icon: 'Display Type Icon',
    display_status_icon: 'Display Status Icon',
    configuration_status_icon: 'Configuration Status Icon',
    gateway_type_icon: 'Gateway Type Icon',
    sensor_status_icon: 'Sensor Status Icon',
    running_state_: 'Running State',
    whether_to_configure: 'Configured?',
    relay_type_icon: 'Repeater Type Icon',
    relay_status_icon: 'Repeater Status Icon',
    operation: 'Actions',
    framework: 'Organization',
    sensor_type_icon: 'Sensor Type Icon',
    nickname_cannot_be_empty: 'Nickname is required.',
    only_english_or_numbers_can_be_entered:
      'Only letters or numbers allowed.',
    type_code_cannot_be_empty: 'Type ID is required.',
    data_type_cannot_be_empty: 'Data type is required.',
    rule_cannot_be_empty: 'Rule is required.',
    please_select_a_device_type: 'Please select the device type.',
    please_enter_the_number_or_name: 'Please enter the ID or name.',
    please_select_a_reason: 'Please select the causes.',
    please_fill_in_the_handler: 'Please enter the handler.',
    please_enter_a_name: 'Please enter a name',
    system_automatic: 'System Auto-execute',
    custom: 'Customize',
    please_enter_the_location: 'Please enter the location.',
    please_enter_longitude: 'Please enter longitude.',
    please_enter_the_latitude: 'Please enter the latitude',
    please_upload_the_plan: 'Please upload the floor plan.',
    select_picture: 'Select Picture',
    confirm_upload: 'Upload System Logo',
    editing_mode: 'Edit Mode',
    please_enter_your_mobile_number: 'Please enter Phone Number.',
    please_enter_wechat: 'Please enter WeChat',
    please_enter_weibo: 'Please enter Weibo',
    reason: 'Causes',
    please_enter_a_task: 'Please enter a task.',
    please_enter_the_interval: 'Please enter the interval.',
    print: 'Print',
    please_enter_the_level_name: 'Please enter a level name.',
    whether_to_automatically_save_the_alarm_object_to_the_contact:
      'Automatically save alarm recipientto contacts?',
    select_a_time_range: 'Select Time Range',
    minute: 'Min',
    cancel: 'Cancel',
    select: 'Checked',
    export_format: 'Export Format',
    please_select_the_export_format: 'Please select the export format.',
    analysis_of_monitoring_points: 'Asset Analysis',
    track: 'Historical Track',
    data_conditions: 'Data Filter',
    select_date: 'Select Date',
    please_select: 'Please Select',
    selected_monitoring_points: 'Selected Asset',
    preview: 'Preview',
    pass_category: 'By Category',
    monitoring_point: 'Asset',
    mounting_details: 'Asset Details',
    statistical_time: 'Statistics Time',
    analysis_type: 'Analysis Type',
    please_select_analysis_type: 'Please select an analysis type.',
    gateway: 'Gateway',
    gateway_details: 'Gateway Details',
    start_year: 'Start Year',
    end_year: 'End Year',
    escalation_rules: 'Report Rules',
    export_template: 'Export Template',
    no_picture_yet: 'No picture available.',
    attribute: 'Attribute',
    application: 'Apply',
    please_enter_the_customer_name: 'Please enter the customer name.',
    please_enter_the_customer_profile: 'Please enter the customer profile.',
    please_enter_the_code: 'Please enter the ID/SN.',
    please_enter_the_area: 'Please enter the customer area',
    please_enter_the_customer_address: 'Please enter the customer address.',
    please_enter_the_contact_person: 'Please enter contact.',
    please_enter_the_contact_information:
      'Please enter the contact.',
    carrier_c: 'Associated  Asset',
    console_c: 'Console:',
    equipment_type: 'Device Type',
    code: 'ID/SN',
    subunits: 'Sub-unit',
    place: 'Place',
    longitude: 'Longitude',
    latitude: 'Latitude',
    position: 'Current Location',
    number_of_used: 'Number of used',
    collection_unit: 'Unit',
    collection_strategy: 'Sampling Policy',
    collection_strategy_1: 'Recent collection points',
    collection_strategy_des_1: 'The system will use sensors in the monitoring points to collect data from the time point closest to the specified recording point as the recording data',
    specified_time: 'Specified Time',
    start: 'Start',
    end: 'End',
    offline_rate: 'Offline Rate',
    pass_rate: 'Pass Rate',
    export_data: 'Export Data',
    please_select_the_preview_monitoring_point:
      'Please select the sensor point to preview.',
    sign: 'Mark',
    file: 'File',
    exception_analysis_settings: 'Abnormal Analysis Settings',
    alarm_trigger_analysis_settings: 'Alarm Trigger Analysis Settings',
    normal_abnormal_proportion_analysis_setting:
      'Normal/Abnormal Ratio Analysis Settings',
    sensor_not_associated: 'Unassociated Sensor',
    gateway_not_associated: 'Unassociated Gateway',
    uncorrelated_display: 'Uncorrelated Display',
    unassociated_relay: 'Unassociated Repeater',
    show_all_properties: 'Show All Properties',
    'pop-up_notification': 'Pop-up Notification',
    display_number: 'Display  ID',
    switch_settings: 'Toggle Settings',
    import_display: 'Import Display',
    number: 'ID/SN',
    sensor_nickname: 'Sensor Nickname',
    file_type: 'File Type',
    whether_to_use_electronic_signature: 'Use E-signature?',
    no_signature_information_yet: 'No signature available.',
    old_password: 'Old Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    temp_unit: 'Temperature Unit',
    celsius:'Celsius',
    fahrenheit:'Fahrenheit',
    kelvin:"Kelvin",
    user_account: 'User Account',
    user_name: 'User Name',
    gender: 'Gender',
    function: 'Function',
    type_name: 'Type Name',
    type_code: 'Type ID',
    type_status: 'Type Status',
    customer_name: 'Company Name',
    customer_profile: 'Company Profile',
    customer_code: 'Company ID',
    customer_status: 'Status',
    customer_type: 'Company Type',
    region: 'Area',
    customer_address: 'Address',
    contacts: 'Contact',
    contact_information: 'Mobile/Phone',
    'e-mail': 'Email',
    inform_the_customer: 'Notify Customer',
    the_meaning_of_the_icon_is_as_follows_c:
      'The meanings of the icons are as follows:',
    sensor_type_icon_c: 'Sensor Type Icon:',
    exception_type_icon_c: 'Abnormal Type Icon:',
    location: 'Location',
    system_customization: 'System Custom',
    print_grouping: 'Print Group',
    data_collection_time_setting: 'Data Sampling Settings',
    use_current_user_name: 'Use Current Username',
    record_point_data: 'Record Point Data',
    use_existing: 'Use Existing',
    use_new_signature: 'Use New Signature',
    total_duration: 'Total Duration',
    please_select_a_preview_device: 'Please select the device to preview.',
    detection_equipment_monitoring: 'Device Real-time Status',
    save_the_selected_device: 'Save Selected Devices',
    monitoring_point_monitoring: 'Asset',
    attribute_list: 'Attribute List',
    display_icon_c: 'Display Icon:',
    gateway_status_icon_c: 'Gateway Status Icon',
    configuration_status_icon_c: 'Configuration Status Icon',
    send_out: 'Send Out',
    log_content_c: 'Log Content:',
    eliminate: 'Clear',
    journal: 'Log',
    configuration_log: 'Configuration Log',
    gateway_icon_c: 'Gateway Icon:',
    relay_icon_c: 'Repeater Icon:',
    relay_status_icon_c: 'Repeater Status Icon:',
    sensor_status_icon_c: 'Sensor Status Icon:',
    mount_type_icon_c: 'Asset Type Icon:',
    network_parameters: 'Network Parameters',
    role: 'Role',
    accessible_organization: 'Accessible Organization',
    operable_resources: 'Operable Resources',
    return_to_the_home_page: 'Return to Home',
    picture_cannot_be_empty: 'Picture is required.',
    email_notification: 'Email Notification',
    sms_notification: 'SMS notification',
    download: 'Download',
    refuse: 'Refuse',
    confirm: 'Confirm',
    return: 'Back',
    // monitoring_interval: 'Monitoring Range',
    monitoring_interval: 'Alarm Range',
    range: 'Range',
    details: 'Details',
    detection_value: 'Detection Value',
    device_type_type_icon_c: 'Device Type Icon:',
    close: 'Close',
    remove: 'Remove',
    refresh: 'Auto Refresh Time',
    deactivate: 'Deactivate',
    enable: 'Enable',
    time_selection: 'Select Time',
    stay: 'In',
    any_point_in_time: 'Any Time Point',
    use_printer: 'Use Printer',
    group_name: 'Group Name',
    please_enter_the_group_name: 'Please enter a group name.',
    print_settings: 'Print Settings',
    print_data: 'Print Data',
    the_group_name_already_exists: 'The group name already exists.',
    please_enter_the_name: 'Please enter name.',
    please_enter_the_number: 'Please enter the number.',
    please_enter_email: 'Please enter the email address.',
    abnormal_connection: 'Disconnected',
    abnormal_data: 'Out of Range',
    abnormal_power_failure: 'Power Off',
    a_uom_can_only_correspond_to_one_monitoring_interval:
      'A UOM can only correspond to one monitoring interval',
    alarm_mode: 'Alarm Mode',
    forwarding_platform: 'Forwarding Platform',
    no_reason_for_alarm: 'No alarm cause available.',
    no_alarm_mode: 'No alarm method available.',
    the_record_point_has_not_been_opened_yet:
      'Data recording not enabled.',
    open_record_point: 'Record Point Enable',
    use_default_settings: 'Use Default Dettings',
    delete_record_point: 'Delete Record Point',
    record_details: 'Record Details',
    view_history: 'View History',
    acquisition_time: 'Reading Time',
    offline_category: 'Offline Type',
    no_preview_data_yet: 'No data to preview.',
    time_zone: 'Time Zone',
    uncorrelated_monitoring_interval: 'Uncorrelated Monitoring Interval',
    please_select_a_test_point: 'Please select a test point.',
    search: 'Search',
    show_anchors: 'Show Markers',
    please_select_a_carrier: 'Please select an Asset.',
    preservation: 'Save',
    archit_: 'Organization',
    down_time_: 'down time ',
    battery_powered: 'Battery Powered',
    creation_time: 'Creation Time',
    command_form: 'Command Form',
    current_step: 'Current Step',
    sampling_detection_value: 'Sample Reading',
    please_enter_the_length: 'Please enter the length.',
    please_enter_a_description: 'Please enter a description.',
    data_type: 'Data Type',
    length: 'Length',
    rule: 'Rule',
    explain: 'Description',
    save_the_selected_monitoring_point: 'Save Selected Asset',
    group_name_cannot_be_empty: 'Group name  is required.',
    operation_failed: 'Operation Failed',
    operation_successful: 'Operation Successful',
    please_upload_the_picture_before_positioning:
      'Please upload the floor plan firstly before positioning.',
    please_select_a_monitoring_point: 'Please select a a sensor point.',
    time_tag: 'Time Tag',
    // to: 'to',
    successful_execution: 'Execution Successful',
    transmit_power_cannot_be_empty: 'TX Power is required.',
    the_network_access_interval_cannot_be_empty:
      'Network Join Interval is required.',
    please_select_the_shortcut_bar_icon: 'Please select the shortcut icon.',
    abroad: 'Overseas',
    mac_address: 'MAC',
    mac_address_c: 'MAC:',
    at_instruction_c: 'AT Command',
    qq_format_is_incorrect: 'QQ format is incorrect.',
    tcp_connection: 'TCP Connection',
    tcp_connection_service_exception: 'TCP connection to server abnormal',
    tcp_connection_service_is_normal: 'TCP connection to server normal',
    lte_connection_server_exception: 'LTE connection to server abnormal',
    lte_connection_server_is_normal: 'LTE connection to server normal',
    zbp_thermometer: 'ZBP Temperature Sensor',
    trace_is_not_an_array: 'Trace is not an array.',
    extpanid_cannot_be_empty: 'ExtPanid is required.',
    at_instruction: 'AT Command',
    mac_cannot_be_empty: 'MAC is required.',
    at_instruction_cannot_be_empty: 'AT Command is required.',
    let_connection_status: 'LTE Connection Status',
    url_already_exists: 'URL already exists.',
    choice: 'Checked',
    handler: 'Handled By',
    temperature_sampling_value: 'Temperature Sampling Value',
    humidity_sampling_value: 'Humidity Sampling Value',
    the_two_passwords_are_inconsistent_e: 'Passwords do not match.',
    unable_to_locate_the_vehicle_e: 'Unable to locate the vehicle.',
    reason_type_icon: 'Cause Type Icon',
    default_condition: 'Default or Not',
    processing_details: 'Handling Details',
    type_of_anomaly: 'Abnormal Type',
    customize_users: 'Custom User',
    current_user: 'Current User',
    handler_cannot_be_blank: 'Handler is required.',
    check_at_least_one_method: 'Please select at least one method.',
    content_cannot_be_empty: 'Content cannot be empty',
    record: 'Record',
    are_you_sure_you_want_to_perform_this_operation_q:
      'Please confirm this operation.',
    _c_: ',',
    normal_size: 'Normal Size',
    the_selected_data_has_a_synchronization_user_c__which_cannot_be_deleted:
      'Selected data includes sync users. Sync users cannot be deleted.',
    no_matching_data_found: 'No matching data found.',
    file_has_been_deleted: 'File has been deleted.',
    file_does_not_exist: 'File does not exist.',
    unknown_error: 'Unknown Error',
    delete: 'Delete',
    download_status: 'Download Status',
    download_failed_c__parameter_error: 'Download failed, parameter error.',
    download_failed_c__the_file_does_not_exist:
      'Download failed, the file does not exist.',
    download_failed_the_file_has_been_deleted:
      'Download failed. The file has been deleted.',
    detection_task_status: 'Detection Task Status',
    alarm_strategy: 'Alarm Policy',
    level_alarm: 'Alarm Level',
    click_to_enable_email_alarm: 'Click to Enable Email Notification',
    click_to_close_the_email_alarm: 'Click to Disable Email Notification',
    click_to_enable_sms_alarm: 'Click to Enable SMS Notification',
    click_to_close_sms_alarm: 'Click to Disable SMS Notification',
    click_to_enable_voice_alarm: 'Click to Enable Voice Notification',
    click_to_close_the_voice_alarm: 'Click to Disable Voice Notification',
    set_up: 'Settings',
    service_number: 'Service ID',
    cancel_work_order: 'Cancel Work Order',
    acceptance: 'Acceptance',
    comment: 'Comment',
    cancellation_succeeded: 'Undo Successful',
    accepted_successfully: 'Acceptance Successful',
    processing_confirmation_c__processing_result_cannot_be_empty:
      'Handling result is required for confirmation.',
    confirmation_succeeded: 'Confirmation Successful',
    star_rating_cannot_be_empty: 'Rating with stars is required.',
    evaluation_success: 'Comment Completed',
    transaction_type: 'Event Type',
    processing_results: 'Handling Results',
    problem_description: 'Issue Description',
    acceptance_method: 'Acceptance Method',
    submitter: 'Submitter',
    acceptor: 'Acceptor',
    submission_time: 'Submission Time',
    acceptance_time: 'Acceptance Time',
    confirmation_time: 'Confirmation Time',
    leaving_a_message: 'Message',
    please_enter_a_message: 'Please leave a message.',
    evaluate: 'Comment',
    please_enter_comments: 'Please enter a comment.',
    reminder_of_submitting_work_order: 'Submit Work Order & Notify Contacts',
    reminder: 'Remind',
    wechat: 'WeChat',
    select_at_least_one_reminder_method: 'Please select at least one notification method.',
    submit: 'Submit',
    customer: 'Company',
    "submitter's_mobile_phone": "Submitter's Mobile",
    transaction_no: 'Event ID',
    please: 'Please',
    approval_of_record_points: 'Approve Record Point',
    please_select_at_least_one_data_e: 'Please select at least one record.',
    operation_succeeded_e: 'Operation Successful',
    no_pictures_of_monitoring_points: 'No sensor point picture available.',
    data_collection_record_is_not_enabled:
      'Data recording not enabled.',
    system_error_c__please_contact_the_relevant_administrator:
      'System error. Please contact the relevant administrator.',
    previous_page: 'Previous Page',
    next_page: 'Next Page',
    auxiliary_settings_of_monitoring_point_equipment:
      'Senor Point Device Auxiliary Settings',
    monitoring_point_status_cannot_be_empty:
      'Sensor point status is required.',
    monitoring_point_name_cannot_be_empty:
      'Sensor point name is required.',
    'the_file_already_exists._do_you_want_to_overwrite_it':
      'File already exists. Overwrite?',
    rear_alarm: 'Rear Alarm',
    sampling_is_used_to_represent_an_overall_value_of_the_monitoring_point_within_the_monitoring_range:
      'Sampling is used to represent an overall value of a sensor point within a monitoring range.',
    set_start_time: 'Set Start Time',
    set_end_time: 'Set End Time',
    qr_code: 'QR Code',
    click_to_load_more: 'More Information',
    query_data: 'Query Data',
    generate_query_code: 'Generate Query Code',
    download_qr_code: 'Download QR Code',
    total_passing_time: 'Total Pass Duration',
    total_length_of_failure: 'Total Failed Duration',
    total_running_time: 'Total Running Time',
    total_offline_time: 'Total Offline Duration',
    the_customer_of_the_account_does_not_need_to_sign_c__please_fill_in_a_new_signature:
      'The customer associated with this account has no signature. Please enter a new signature.',
    view_tracks: 'View Track',
    please_select_the_device_to_analyze_first:
      'Please select the device to analyze first.',
    no_selected_device_data: 'No data for selected device.',
    this_device_already_exists: 'This device already exists.',
    no_associated_devices_found: 'No associated device found.',
    monitoring_point_has_no_associated_map_unit:
      'The sensor point is not associated with any map unit.',
    detailed_information: 'Details',
    please_select_a_track_point: 'Please select a track point.',
    no_track_found_e: 'No track found.',
    real_time_trajectory: 'Real-time Tracking',
    historical_track: 'Historical Track',
    no_action_track_detected: 'No movement track detected.',
    this_map_unit_has_no_monitoring_points:
      'This map unit has no sensor points.',
    no_monitoring_point_data: 'No sensor point data.',
    open_anchor: 'Enable Mark',
    multiple_combined_numbers_are_separated_by_commas_and_are_numbers:
      'Multiple combined numbers should be separated by commas.',
    above_safety_range: 'Above Safe Range',
    below_safety_range: 'Below Safety Range',
    modification_succeeded_c__please_login_again:
      'Update successful. Please login again.',
    need_to_be_dealt_with: 'To-Do List',
    fixed_monitoring_point: 'Fixed Asset',
    mobile_monitoring_point: 'Mobile Asset',
    unable_to_locate_the_mobile_monitoring_point_e:
      'Unable to locate the mobile sennsor point.',
    unassociated_device: 'Unassociated Device',
    time: 'Time',
    speed: 'Speed',
    sampling: 'Sampling',
    unrelated_temperature_range: 'Temperature range is not associated.',
    unrelated_humidity_range: 'Unassociated RH Range',
    sensor: 'Sensor',
    relay: 'Repeater',
    'deleting_a_monitoring_point_type_will_delete_all_data_under_this_type._are_you_sure_you_want_to_do_this_q':
      'Delete this sensor point type? All related data will be deleted. Confirm?',
    decimal_type_c__the_length_is_separated_by_a_comma_c__and_only_one_comma_is_allowed:
      'Decimal type, the length is separated by a comma, and only one comma is allowed.',
    platform_or_not: 'Platform or not',
    view_positioning: 'View Location',
    'deleting_a_device_type_will_delete_all_data_under_that_type._are_you_sure_you_want_to_do_this_q':
      'Delete this device type? All related data will be deleted. Confirm?',
    system_error_c__please_contact_the_administrator:
      'System error. Please contact the administrator.',
    submitter_quo_s_mobile_phone: "Submitter's Mobile",
    work_order_status: 'Work Order Status',
    please_enter_the_end_date: 'Please enter the end date.',
    monitoring_point_details: 'Asset Details',
    collection_interval_cannot_be_empty: 'Sampling Interval is required.',
    exception_collection_interval_cannot_be_empty:
      'Abnormal Sampling Interval is required.',
    the_temperature_collection_interval_cannot_be_empty:
      'Temperature sampling interval is required.',
    temperature_change_threshold_cannot_be_empty:
      'Temperature change threshold is required.',
    the_maximum_temperature_reporting_interval_cannot_be_empty:
      'Max. Temperature Report Interval is required.',
    the_minimum_reporting_interval_of_temperature_cannot_be_empty:
      'Min. Temperature Report Interval is required.',
    humidity_collection_interval_cannot_be_empty:
      'Humidity Sampling interval is required.',
    humidity_change_threshold_cannot_be_empty:
      'RH change threshold is required.',
    the_maximum_humidity_reporting_interval_cannot_be_empty:
      'Max. RH Report Interval is required.',
    the_minimum_humidity_reporting_interval_cannot_be_empty:
      'Min. RH Report Interval is required.',
    jingxian_county: 'Jingxian County',
    trigger_settings: 'Trigger Settings',
    please_enter_the_name_of_the_monitoring_point:
      'Please enter a sensor point name.',
    title: 'Title',
    query_code: 'Query Code',
    login_code: 'Login Code',
    please_use_the_applet_to_scan_and_log_in_within_five_minutes:
      'Please scan to login within five minutes.',
    current: 'Current',
    collection: 'Sampling',
    temperature_range_without_monitoring: 'Temperature range is not associated.',
    click_sign_out: 'Click to Deactivate',
    click_activate: 'Click to Activate',
    please_pass_in_an_array_with_the_correct_format:
      'Please pass an array in the correct format.',
    please_pass_in_the_object_property: 'Please pass in the object attributes.',
    branch: 'Min',
    surplus: 'Remaining/Balance',
    turn_off_alarm: 'Disable Alarm',
    turn_on_alarm: 'Enable Alarm',
    delay_normal_alarm: 'Normal Alarm Delay',
    delay_ignore_alarm: 'Ignore Alarm Delay',
    no_matter_whether_the_data_becomes_normal_within_the_delay_time_c__the_abnormal_alarm_will_still_alarm:
      'During the delay period, the abnormal alarm persists regardless of whether the data returns to normal.',
    a_delay_alarm_is_set_in_the_layered_alarm_dot__within_the_delay_time_c__the_data_becomes_normal_again_c__and_the_alarm_trigger_will_ignore_the_alarm_and_will_not_alarm_again:
      'Delay is set in the graded Alarm. If data returns to normal within the delay period, the alarm trigger will ignore and suppress the alarm.',
    default: 'Default',
    deactivation_status: 'Deactivation Status',
    alarm_off: 'Alarm Off',
    untraceable: 'Untraceable',
    heat_insulation_box: 'Incubator',
    'Offline': 'Offline',
    configuring: 'Configuring',
    normal_request_response_c__but_failed:
      'Request sent normally, but no response received.',
    the_account_does_not_exist: 'The account does not exist.',
    password_error: 'Incorrect Password',
    credential_error: 'Account, email or password incorrect',
    login_credential_expired_c__please_login_again:
      'Login credential expired, please login again.',
    no_permission_c__please_contact_the_administrator:
      'No permission. Please contact the administrator',
    login_failed: 'Login Failed',
    login_conflict: 'Login Conflict',
    do_not_log_in_again: 'Duplicate login not allowed.',
    the_requested_resource_does_not_exist:
      'Requested resource not found.',
    wrong_request_method: 'Invalid request method.',
    network_anomaly: 'Network Abnormal',
    exporting_data: 'Exporting Data',
    export_succeeded: 'Export Successful',
    zhang_shan: 'Zhang Shan',
    asa: 'Asa',
    li_si: 'Li Si',
    // nothing: 'nothing',
    please_enter_the_correct_name_e: 'Please enter a valid name.',
    please_enter_the_correct_email_e: 'Please enter a valid email address.',
    id_card_cannot_be_empty: 'ID card is required.',
    'please_enter_the_correct_second-generation_id_card_number':
      'Please enter a valid ID Card number.',
    phone_cannot_be_empty: 'Phone is required.',
    only_english_letters_and_numbers_can_be_included:
      'Only letters and numbers are allowed.',
    cannot_contain_spaces: 'Cannot contain spaces.',
    it_can_only_contain_english_letters_c__numbers_and_underscores:
      'Only letters, numbers, and underscores are allowed.',
    param_code_can_only_contain_letters_numbers_and_symbols:
      'It can only contain letters, numbers and symbols (spaces not allowed)',
    please_fill_in_the_address_correctly:
      'Please enter a valid address.',
    only_numbers_or_letters_can_be_entered_e:
      'Only letters or numbers allowed.',
    two_decimal_places_and_numbers: 'Should be a number with two decimal places.',
    no_decimal_point: 'Decimal point not allowed.',
    please_enter_a_number: 'Please enter a number.',
    parameter_verification_failed: 'Parameter Verification Failed',
    track_information: 'Track Information',
    'this_operation_will_remove_all_monitoring_point_anchors._are_you_sure_this_operation_q':
      'This operation will remove all location markers of sensor points. Confirm?',
    this_operation_will_remove_all_monitoring_point_anchors_dot__are_you_sure_this_operation_q:
      'This operation will remove all location markers. Confirm?',
    deleting_a_monitoring_point_type_will_delete_all_data_under_this_type_dot__are_you_sure_you_want_to_do_this_q:
      'Delete this sensor point type? All related data will be deleted. Confirm?',
    deleting_a_device_type_will_delete_all_data_under_that_type_dot__are_you_sure_you_want_to_do_this_q:
      'Delete this device type? All related data will be deleted. Confirm?',
    after: 'after',
    processing_confirmation: 'Handling Confirmation',
    continue_processing: 'Continue Handling',
    back: 'Back',
    confirm_close: 'Confirm Close',
    edit: 'Edit',
    please_select_trigger: 'Please select a trigger.',
    temperature_detection_value: 'Temperature Reading',
    humidity_detection_value: 'RH Reading',
    please_enter_an_integer_greater_than_zero:
      'Please enter an integer greater than 0.',
    length_is_less_than_30: 'Maximum length is 30 characters.',
    name_length_is_within_30: 'Name maximum length is 30 characters.',
    code_length_is_within_50: 'The ID length cannot exceed 50 characters.',
    '3_times_smaller': 'Zoom Out 3x',
    '2x_smaller': 'Zoom Out 2x',
    zoom_in_2x: 'Zoom In 2x',
    zoom_in_3x: 'Zoom In 3x',
    length_within_50: 'Maximum length is 50 characters.',
    length_within_20: 'Maximum length is 20 characters.',
    length_within_255: 'Maximum length is 255 characters.',
    length_within_100: 'Maximum length is 100 characters.',
    interval_length_is_within_4: 'Interval length is within 4.',
    please_enter_an_integer_greater_than_0:
      'Please enter an integer greater than 0.',
    please_enter_a_positive_integer_greater_than_0:
      'Please enter a positive integer greater than 0.',
    please_enter_an_integer_greater_than_or_equal_to_0:
      'Please enter an integer greater than or equal to 0.',
    the_length_of_monitoring_point_is_within_50:
      'Sensor point length must not exceed 50 characters.',
    the_length_of_monitoring_point_is_within_250:
      'Sensor point length must not exceed 250 characters.',
    length_cannot_exceed_80: 'Maximum length is 80 characters.',
    the_length_is_8_hex_bases_c__i_dot_e_dot__18:
      'Length is 8 bytes hexadecimal characters with 0x prefix, total18 characters.',
    the_length_of_trunk_number_cannot_be_greater_than_50:
      'Repeater ID length must not exceed 50 characters.',
    number_length_cannot_be_greater_than_30:
      'The ID length cannot exceed 30 characters.',
    length_less_than_50: 'Maximum length is 50 characters.',
    length_within_120: 'Maximum length is 120 characters.',
    customer_name_cannot_be_greater_than_50_in_length:
      'Maximum length for customer name is 50 characters.',
    company_name_cannot_be_greater_than_50_in_length:
      'The length of company name cannot be greater than 50 characters.',
    the_customer_abbreviation_cannot_be_greater_than_30:
      'Customer abbreviation must not exceed 30 characters.',
    the_area_cannot_be_longer_than_120: 'Area maximum length is 120 characters.',
    the_customer_address_cannot_be_greater_than_255_in_length:
      'Customer address must not exceed 255 characters.',
    customer_contact_cannot_be_longer_than_30:
      'Maximum length for customer contact is 30 characters.',
    description_cannot_be_longer_than_250:
      'Description length cannot exceed 250 characters.',
    name_within_20: 'Name maximum length is 20 characters.',
    type_name_within_20: 'Type name maximum length is 20 characters.',
    length_within_80: 'Maximum length is 80 characters.',
    see: 'View',
    return_to_search_criteria: 'Return to Search',
    current_value: 'Current Value',
    maximum: 'Maximum',
    minimum_value: 'Minimum',
    average_value: 'Average',
    anchor_list_c: 'Marker List',
    configuration_details: 'Configuration Details',
    plan_information: 'Plan Information',
    plan_editing: 'Plan Editing',
    no_description_information: 'No description available.',
    customer_location: 'Location',
    contents_menu: 'Menu',
    example: 'Example',
    organizational_unit: 'Organization',
    alarm_reason: 'Cause',
    alarm_level: 'Alarm Level',
    alarm_object: 'Alarm Recipient',
    phone_number: 'Phone Number',
    alarm_time: 'Alarm Time',
    alarm_content: 'Alarm Content',
    hierarchy: 'Level Name',
    'no_dot_/name': 'ID/Name',
    'equipment_name/no': 'Device Name/ID',
    sensor_temp: 'Temperature',
    sensor_hum: 'Relative Humidity',
    now_in_viewing_status_c__please_return_to_processing_status:
      'Please back to handling mode. Currently in view mode.',
    processed_c__processing_information_can_be_viewed_in_the_record:
      'Handled. You can view the handling details in the records.',
    processing_times_c__click_to_process_exception_records:
      'Handling Count. Click to handle abnormal records.',
    point_data_arrival_c: 'Point Data Arrival:',
    this_operation_will_delete_its_child_nodes_and_monitoring_points_dot__do_you_want_to_continue_q:
      'This operation will delete child nodes and sensor points. Continue?',
    same_record_exists_c__duplicate_record_skipped:
      'Duplicate records found, skipped.',
    please_enter_an_msn: 'Please enter the MSN.',
    please_enter_skype: 'Please enter Skype.',
    only_generated_and_failed_records_can_be_deleted:
      'Only generated or failed records can be deleted.',
    _quo_this_operation_will_permanently_delete_this_information_dot__are_you_sure_you_want_to_do_this_q_quo_:
      'This operation will permanently delete this information. Continue?',
    when_the_unit_is_seconds_c__it_cannot_be_less_than_10:
      'When the unit is seconds, it cannot be less than 10.',
    this_operation_will_clear_the_alarm_object_and_its_contacts:
      'This operation will  delete the alarm recipients.',
    there_is_data_with_usage_times_other_than_0_and_cannot_be_deleted:
      'Cannot delete because some data has a non-zero usage count.',
    whole: 'All',
    default_settings_not_found_c__please_contact_administrator:
      'Default settings not found, please contact administrator.',
    no_gateway_zigbee_related_parameters:
      'No Gateway Zigbee Parameters',
    currently_in_view_mode_c__unable_to_process:
      'Currently in view mode. Unable to process.',
    query_code_valid_time_c_7_days: 'Query Code valid time: 7 days',
    this_file_already_exists_dot__do_you_want_to_overwrite_it_q:
      'This file already exists. Do you want to overwrite it?',
    warn_c_illegal_year: 'Warning: Invalid year',
    alarm_switch: 'Alarm Toggle',
    alarm_data_delay: 'Data Delay',
    alarm_offline_delay: 'Offline Delay',
    alarm_volume_: 'alarm volume ',
    number_of_alarms: 'Alarm Count',
    number_of_labels_per_page: 'Items per Page',
    the_mac_length_cannot_be_greater_than_30:
      'The MAC length cannot be greater than 30 characters.',
    the_mac_length_cannot_be_greater_than_50:
      'The MAC length cannot be greater than 50 characters.',
    alarm_parameters: 'Alarm Parameters',
    mqtt_address: 'MQTT Broker Address',
    mqtt_port: 'MQTT Port',
    mqtt_connection_timeout: 'MQTT Connection Timeout',
    mqtt_automatic_reconnection: 'MQTT Auto Reconnection',
    data_storage_time: 'Data Retention Period',
    equipment_limited_quantity: 'Device Quantity Limit',
    to_configure: 'Configuration',
    no_gateway_zigbee_parameter: 'No Gateway Zigbee Parameters',
    relay_mac: 'Repeater MAC',
    forwarding_gateway_mac: 'Forwarding Gateway MAC',
    appeui_cannot_be_empty: 'appEUI is required.',
    appkey_cannot_be_empty: 'AppKey is required.',
    deveui_cannot_be_empty: 'devEUI is required.',
    the_password_length_exceeds_the_limit:
      'Password length exceeds limit.',
    the_selected_data_has_an_enabled_state_and_cannot_be_deleted:
      'Selected Item includes enabled status. Delete failed.',
    select_at_least_one_monitoring_point_type:
      'Please select at least one sensor point type.',
    customer_creation_succeeded_c__but_default_role_creation_failed:
      'Customer created successfully, but failed to create the default role.',
    create_customer_c__default_role_succeeded_c__but_create_user_failed:
      'Create customer, default role succeeded, but create user failed.',
    create_customer_c__default_role_c__user_succeeded_c__but_contact_synchronization_failed:
      'Customer, default role, and user created successfully, but failed to sync contacts.',
    customer_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__and_numbers_cannot_be_greater_than_20_in_length:
      'Customer ID can only contain uppercase and lowercase letters and digits, and the length cannot exceed 20 characters.',
    company_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__and_numbers_cannot_be_greater_than_20_in_length:
      'Company ID can only be filled in uppercase and lowercase English letters, and numbers. The length cannot be greater than 20 characters.',
    the_area_code_can_only_be_filled_in_uppercase_and_lowercase_english_letters_c__numbers_c__and_underscores_c__and_cannot_be_greater_than_20_in_length:
      'Area code can only contain uppercase and lowercase letters, numbers, and underscores, and cannot exceed 20 characters in length.',
    contact_information_can_only_be_filled_with_numbers_and_middle_bars_c__and_cannot_be_greater_than_20_in_length:
      'Contact information can only contain numbers and hyphens, and cannot exceed 20 characters in length.',
    customer_editing_succeeded_c__but_default_role_editing_failed:
      'Customer editing succeeded, but default role editing failed',
    _quo_edit_customer_c__default_role_succeeded_c__but_edit_user_failed_quo_:
      'Customer and default role updated successfully, but failed to update user.',
    _quo_edit_customer_c__default_role_c__user_succeeded_c__but_contact_synchronization_failed_quo_:
      'Customer, default role, and user updated successfully, but failed to sync contacts.',
    only_english_c__numbers_c__and_underscores_are_allowed:
      'Only letters, numbers, and underscores are allowed.',
    open: 'Enable',
    coordinator_name: 'Coordinator Name',
    configuration_information: 'Configuration Information',
    gateway_coordinator: 'Gateway Coordinator',
    self_ip_attribute: 'Self IP Attribute',
    private_ip: 'Private IP',
    switch_proxy_customers: 'Switch Agent Company',
    switching_succeeded_c__please_log_in_again:
      'Switch successful. Please login again.',
    the_current_customer_is_already_a_selected_customer_and_does_not_need_to_be_switched:
      'The current customer is already selected. No need to switch.',
    device_records_associated_with_monitoring_points_c__activated_c__and_in_use:
      'Device records that are associated with monitoring points, activated, and currently in use.',
    device_records_that_have_been_activated_and_are_in_use_c__but_have_not_been_associated_with_a_monitoring_point:
      'Device records that have been activated and are in use, but have not been associated with a sensor point.',
    device_records_associated_with_a_monitoring_point_and_activated_c__but_the_device_has_been_deactivated:
      'Device records that were previously associated with sensor points and activated, but are now deactivated.',
    equipment_records_that_have_been_added_but_have_not_been_activated:
      'Devices that have been added but have not been activated.',
    server_error_c__request_failed_c__please_contact_management:
      'Server error, request failed, please contact administrator.',
    login_expired_c__please_login_again: 'Login expired, please login again.',
    server_error_c__please_contact_administrator:
      'Server error, please contact administrator.',
    request_timed_out_c__please_contact_the_administrator:
      'Request timeout. Please contact the administrator.',
    a_system_error_occurred_and_the_download_failed:
      'System error occurred, download failed.',
    the_file_is_corrupted_dot__please_rebuild_it_and_try_again:
      'The file is corrupted. Please regenerate and try again.',
    extpanid_format_is_hexadecimal: 'ExtPANID is in hexadecimal.',
    wang_wu: 'Wang Wu',
    it_quo_s_json: "JSON Format",
    the_input_content_is_a_positive_integer_and_the_maximum_length_is_5:
      'Input must be a positive integer up to 5 digits.',
    cannot_exceed_255: 'Cannot exceed 255',
    cannot_be_greater_than_327: 'Cannot exceed 327.',
    cannot_be_greater_than_30: 'Cannot exceed 30.',
    cannot_be_less_than_0: 'Cannot be less than 0',
    cannot_be_greater_than_26: 'Cannot exceed 26.',
    cannot_be_less_than_11: 'Cannot be less than 11',
    cannot_be_greater_than_60: 'Cannot exceed 60.',
    cannot_be_greater_than_20: 'Cannot exceed 20.',
    cannot_be_greater_than_100: 'Cannot exceed 100.',
    please_enter_the_correct_url_e: 'Please enter a valid URL.',
    length_cannot_exceed_100: 'Maximum length is 100 characters.',
    the_length_can_only_be_16_bits: 'Length must be exactly 16 bits.',
    the_content_is_only_in_figures_and_english:
      'Only numbers and letters allowed.',
    the_length_can_only_be_10_digits: 'Length must be exactly 10 digits.',
    the_length_can_only_be_32_bits: 'Length must be exactly 32 bits.',
    add: 'New',
    architecture: 'Organization',
    start_time: 'Start Time',
    end_time: 'End Time',
    no_query_data_temporarily: 'No data found for the query.',
    real_time_situation_of_monitoring_points:
      'Real-time Status of Asset',
    'exception_type_(icon_illuminated_as_exception)':
      'Abnormal Type (Highlight means abnormal)',
    'duration_(seconds)': 'Duration(s)',
    'interval_time_(seconds)': 'Interval(s)',
    'time_interval_(seconds)': 'Time Interval(s)',
    'alarm_time_(seconds)': 'Alarm Time(s)',
    'alarm_interval_(seconds)': 'Alarm Interval (s)',
    'network_access_interval_(seconds)': 'Join Network Interval(s)',
    volts: 'Volts',
    cannot_be_empty: 'Be required.',
    data_record: 'Data Record',
    adopt: 'Approved',
    input_verification_failed: 'Input validation failed.',
    continued: 'Duration',
    not_applied: 'Not Applied',
    be_applied_to: 'Apply To',
    type_details: 'Type Details',
    query_was_successful: 'Query Successful',
    successfully_added: 'Successfully Added',
    edit_failed: 'Edit Failed',
    edit_succeeded: 'Edit Successful',
    alarm_trigger_bound_to_carrier: 'Alarm Trigger already bound to an asset.',
    display_name_already_exists: 'Display name already exists',
    import_an_empty_file: 'Import an Empty File',
    import_failed: 'Import Failed',
    import_succeeded: 'Import Successful',
    please_re_import_the_correct_template_file:
      'Please re import the correct template file',
    gateway_mac_already_exists: 'Gateway MAC already exists.',
    sending_succeeded: 'Send Successful',
    fail_in_send: 'Send Failed',
    purge_succeeded: 'Clear Succcessful',
    mac_is_empty: 'MAC is NULL.',
    the_parent_menu_does_not_exist_c__it_may_have_been_deleted:
      'The parent menu does not exist, it may have been deleted.',
    query_failed: 'Query Failed',
    successfully_saved_in_batch: 'Batch Save Successful',
    sort_succeeded: 'Sort Successful',
    sort_failed: 'Sort Failed',
    definition: 'Define',
    historical_data_: 'Historical Data',
    'only_jpg/png_files_can_be_uploaded_c__and_no_more_than_500kb':
      'Only JPG/PNG files up to 500KB are allowed.',
    'please_enter/select_a_contact_person':
      'Please enter/select a contact person.',
    'when_the_unit_is_minute/hour_c__it_cannot_be_less_than_1':
      'When the unit is minute/hour, it cannot be less than 1.',
    'please_enter_a_number/name': 'Please enter the ID/name.',
    'when_logging_off_a_customer_c__the_associated_roles/users/monitoring_tools/monitoring_points_will_be_deactivated_dot__are_you_sure_you_want_to_log_off_q':
      'Deactivating this customer will also disable associated roles, users, monitoring tools, and monitoring points. Confirm deactivation?',
    record_point_closed: 'Record Point Disabled',
    more: 'More',
    there_are_currently_no_monitoring_points_available:
      'No sensor points available.',
    normal_time: 'Normal Running Time',
    abnormal_time: 'Abnormal Time',
    monitoring_device_connection_failure:
      'Monitoring Device Connection Failed.',
    standby_power_supply_for_device_startup:
      'Device Backup Power Activated',
    no_comment_information: 'No Comments',
    installation_point: 'Location',
    remarks: 'Remark',
    closing_time: 'Closed Time',
    duration: 'Duration',
    processing_records: 'Handling Records',
    not_closed: 'Not Closed',
    abnormal_record_details: 'Event Information',
    abnormal_cause: 'Cause',
    please_fill_in_the_reason: 'Please enter the causes.',
    unable_to_find_corresponding_reason: 'Unable to find corresponding causses.',
    '': '',
    system_abnormality: 'System Abnormal',
    of: 'of',
    abnormal_object: 'Abnormal Object',
    must_select_the_same_customer: 'Must select the same customer.',
    unprocessed: 'Pending',
    are_you_sure_you_want_to_delete_this_exception_q:
      'Please confirm to delete this abnormal record.',
    details_of_abnormal_content: 'Abnormal Record Details',
    abnormal_content: 'Abnormal Information',
    process_and_stop_alarms: 'Handle and Stop Alarms',
    alarm_triggering: 'Alarm Trigger',
    the_deleted_schema_is_a_scope_and_cannot_be_deleted:
      'The organization to be deleted is a scope and cannot be deleted.',
    the_schema_is_in_use_and_cannot_be_deleted:
      'The organization is in use and cannot be deleted.',
    interval_alarm_or_not: 'Intermittent Alarm or Not',
    alarm_interval: 'Alarm Interval (s)',
    there_is_currently_no_content_available:
      'No Content Available',
    the_minimum_unit_of_alarm_interval_is_minutes:
      'The unit of alarm interval should be in minutes.',
    alarm_time_and_time_point_cannot_be_empty:
      'Alarm Time/Point  are required.',
    alarm_record: 'Alarm Records',
    please_select_the_same_customer: 'Please select the same customer.',
    other_information: 'Other Info.',
    sampling_strategy: 'Sampling Policy',
    abnormal_detachment: 'Drop-off',
    data_strategy: 'Data Policy',
    successfully_applied: 'Application Successful',
    installation_point_name: 'Location Name',
    association_method: 'Association Method',
    using_a_smart_base: 'Apply Smart Bracket',
    please_enter_or_select_a_base_name: 'Please enter or select a bracket name.',
    equipment_no: 'Device ID',
    please_select_a_device_first: 'Please select the device first.',
    associated_devices: 'Associated Device',
    base: 'Bracket',
    base_strategy: 'Bracket Rules',
    please_add_a_probe_first: 'Please add a sensor first.',
    currently_associating_devices_c__please_complete_the_addition_before_switching:
      'Currently associating device. Please complete the addition before switching.',
    currently_adding_c__please_save_or_delete_and_try_again:
      'Currently adding. Please save or delete before trying again.',
    new_name: 'New Name',
    please_enter_the_association_name: 'Please enter the associated name.',
    please_select_the_device_to_be_associated:
      'Please select the device to associate.',
    the_device_is_already_bound_to_a_monitoring_point:
      'The device is already associated to a asset.',
    successfully_added_installation_point:
      'Successfully added installation point',
    are_you_sure_you_want_to_delete_this_item:
      'Please confirm to delete this item.',
    are_you_sure_you_want_to_dissociate_this_device:
      'Please confirm to  dissociate this device.',
    the_installation_point_does_not_exist:
      'The sensor point does not exist.',
    installation_point_details: 'Asset Details',
    please_select_a_smart_base: 'Please select a smart bracket.',
    the_device_has_been_associated_with_a_monitoring_point:
      'Device already associated with a sensor point.',
    the_device_is_already_associated_with_the_current_monitoring_point:
      'Device already associated with a sensor point.',
    smart_sled_not_bound: 'Unassociated Smart Bracket',
    chart: 'Chart',
    this_device_has_no_historical_data: 'This device has no historical data.',
    please_select_a_schema_first: 'Please select an organization first.',
    alarm_trigger_switch: 'Alarm Toggle',
    please_select_a_monitoring_point_for_the_associated_trigger:
      'Please select the sensor point associated with the trigger.',
    sampling_time: 'Sampling Time',
    sampling_value: 'Sampling Value',
    rendering: 'Render',
    no_monitoring_interval: 'No monitoring Range',
    equipment: 'Device Name',
    eq_off:'Device(Offline)',
    eq_on:'Device(Online)',
    collect_data: 'Readings',
    news: 'News',
    unassociated_monitoring_points: 'Unassociated Asset',
    vcn_switcher_: 'VCN Switcher ',
    bind_device: 'Device Association',
    base_number: 'Bracket ID',
    base_type: 'Bracket Type',
    nickname: 'Nickname',
    the_base_type_cannot_be_empty: 'The bracket type is required.',
    the_base_nickname_cannot_be_empty: 'The bracket nickname is required.',
    the_base_code_cannot_be_empty: 'The bracket ID is required.',
    import_smart_base: 'Import Smart Bracket',
    start_date: 'Start Date',
    end_date: 'End Date',
    binding_history: 'Binding History',
    device_selection: 'Select Device',
    please_enter_the_device_number: 'Please enter the device ID.',
    do_you_want_to_force_replacement: 'Please confirm wheather to force replacement.',
    unassociated_base: 'Unassociated Bracket',
    this_device_is_already_associated_with_a_base_dot__are_you_sure_you_want_to_forcibly_replace_it_q:
      'This device is already associated with a bracket. Are you sure you want to forcibly replace it?',
    binding_successful: 'Binding Successful',
    conflict_resolution: 'Conflict Handling',
    the_base_conflicts_with_the_device_monitoring_point_dot__please_choose_the_following_handling_method_c:
      'The bracket conflicts with the sensor point. Please choose the following handling method:',
    bind_device_c__associate_to__b: 'Bind device, associate to',
    bind_devices_and_disassociate_installation_points:
      'Bind devices, disassociate sensor point.',
    base_binding_status: 'Bracket Association Status',
    data_processing: 'Data Processing',
    status: 'Status',
    fall_off: 'Drop-off',
    embed: 'Embed',
    binding: 'Binding',
    unbound_monitoring_point: 'Unassociated Asset',
    bound_monitoring_point: 'Asset Associated',
    new_smart_base: 'New Smart Bracket',
    analyze_data: 'Analysis Data',
    viewing_data: 'View Data',
    fill_preview: 'Preview',
    fill_in_data: 'Fill In Data',
    please_enter_the_gateway_name: 'Please enter the gateway name.',
    closed: 'Disable',
    monitoring_point_chart: 'Asset Chart',
    event: 'Event',
    event_information: 'Event Information',
    company: 'Company',
    batch_handle: 'Batch Handle',
    handle_time: 'Handle Time',
    operation_time: 'Operation Time',
    trigger_name_: 'Trigger Name ',
    work_order: 'Work Order',
    secondment: 'Loan',
    alarm_switch_event: 'Alarm Toggle Event',
    click_to_jump_to_the_download_page_for_download:
      'Click here to access the download page.',
    query: 'Search',
    overall_situation_of_equipment_secondment:
      'Device Loan Overview',
    current_secondment: 'Current Loaned Device',
    historical_secondment: 'Loan History',
    revoke: 'Undo',
    source_device: 'Source Device',
    secondment_to: 'Loan To',
    secondment_confirmation: 'Loan Confirmation',
    select_all: 'Select All',
    please_select_at_least_one_piece_of_data:
      'Please select at least one record.',
    equipment_secondment_cancellation: 'Cancel Device Loan',
    revoke_confirmation: 'Confirm Undo',
    are_you_sure_you_want_to_delete_these_data_q:
      'Please confirm to delete these data.',
    secondment_remarks: 'Loan Remark',
    revoke_remarks: 'Remark',
    please_select_the_unit_that_needs_to_be_seconded_to:
      'Please select the unit to loan to.',
    explanation_c_when_the_equipment_is_seconded_c__the_original_monitoring_points_c__organizational_structure_c__etc_dot__associated_with_the_equipment_will_be_revoked:
      'Note: When a device is on loan, its previously associated sensor points, organizational structures, etc. will be cancled.',
    type_of_seconded_equipment: 'Loan Device Type',
    secondment_view: 'View Loan',
    equipment_secondment: 'Device Loan',
    only_devices_currently_on_secondment_can_view_details:
      'Details can only be viewed for devices currently on loan.',
    equipment_secondment_details: 'Device Loan Details',
    cannot_select_a_device_that_is_currently_being_seconded_for_secondment:
      'Cannot select a device that is currently on loan.',
    only_devices_currently_on_secondment_can_be_selected_for_cancellation:
      'Only devices currently on loan can be selected for cancellation.',
    the_selected_record_must_be_a_seconded_record:
      'Selected record must be a currently loaned record.',
    select_at_least_one_record: 'Please select at least one record.',
    you_must_select_a_non_seconded_record:
      'Must select a record that is not on loan.',
    thermometer_base: 'Smart Bracket',
    account_type: 'Account Type',
    account_status: 'Account Status',
    default_account: 'Default Account',
    selected_data_state_has_start: "The selected data includes items with 'Started' status. Please reselect.",
    selected_data_state_has_stop: "The selected data state has a 'Stop' status, please select again",
    please_select_device: 'Please select a device.',
    sign_as: 'Status',
    confirm_abnormal_msg: 'Confirmed',
    suspected_abnormal_msg: 'Pending',
    confirm_normal_msg: 'False',
    display_info: 'Display Information',
    phone_notification: 'Voice Notification',
    each_week: 'Every Week',
    each_month: 'Every Month',
    each_year: 'Every Year',
    last_day: 'Last Day',
    notice_type: 'Status',
    enter_rule_name: 'Please enter the rule name',
    temp_data_rule: 'Temperature Data Rules',
    hum_data_rule: 'Humidity Data Rules',
    device_offline_rule: 'Device Offline Rules',
    power_off_rule: 'Device Power-Off Rule',
    rule_exists: 'This rule already exists.',
    unm_fault_tolerant: 'Value Tolerance',
    time_fault_tolerant: 'Time Tolerance',
    continuity_anomaly: 'Persistent Abnormal',
    abnormal_frequency: 'Abnormal Frequency',
    reconnect_duration: 'Reconnection Duration',
    power_duration: 'Power Outage Duration',
    please_add_rule: 'Please add rules.',
    add_rule_title: 'Add Rule',
    select_point: 'Select Asset',
    rule_association: 'Associate Invalid Rule',
    ex_state: 'Abnormal Situation',
    quarter: 'Quarter',
    direct_statistics: 'Statistics',
    alarm_object_num: 'Alarm Recipient Count',
    one_quarter: 'Q1',
    two_quarter: 'Q2',
    three_quarter: 'Q3',
    four_quarter: 'Q4',
    exclude_abnormal: 'Status',
    confirm_abnormal: 'Confirm Abnormal',
    suspected_abnormal: 'Suspected Abnormal',
    sampling_frequency_cannot_be_empty: 'The sampling frequency is required.',
    monitoring_interval_cannot_be_empty: 'The monitoring range is required.',
    gas_type_icon: 'Gas Sensor Type Icon',
    gas_status_icon: 'Gas Sensor Status Icon',
    temp_hum_type_icon: 'Temp&RH Sensor Type Icon',
    temp_hum_status_icon: 'Temp&RH Sensor Status Icon',
    new_gas: 'New Gas Sensor',
    gas_code: 'Gas Sensor ID',
    gas_type: 'Gas Sensor Type',
    gas_status: 'Gas Sensor Status',
    alarm_threshold: 'Alarm Threshold',
    magnetism_code: 'Door Sensor ID',
    magnetism_type: 'Door Sensor Type',
    magnetism_type_icon: 'Door Sensor Type Icon',
    magnetism_status_icon: 'Door Sensor Status Icon',
    new_magnetism: 'New Door Sensor',
    magnetism_status: 'Door Sensor Status',

    plane_unit: 'Plane Unit',
    map_unit: 'Map Unit',

    // buffer_interval: 'Buffer interval',
    buffer_interval: 'Warning Range',
    gas: 'Gas',
    magnetism: 'Door Sensor',
    display_buffer_interval: 'Display Buffer Interval',
    from: 'From',
    to: 'to',
    data_compare: 'Data Comparison',
    gps_p: 'GPS Positioning',
    async_mode: 'Asynchronous Mode',
    sync_mode: 'Synchronous Mode',
    fix_mode: 'Fixed Mode',
    interval_variation_mode: 'Range Variation Mode',
    normal_mode: 'Normal Mode',
    transport_mode: 'Transportation Mode',
    transportation_mode: 'Transportation Mode',
    no_relevant_parameters: 'No related parameters obtained.',
    audio_alarm: 'Sound Alarm',
    light_alarm: 'Light Alarm',
    sound_light_alarm: 'Sound & Light Alarm',
    network_parameters_01: 'Gen1 Network Parameters',
    network_parameters_02: 'Gen2 Network Parameters',
    year_2: 'Year',
    device_historical_line_chart: 'Device Historical Curve',
    sample_historical_line_chart: 'Historical Line Chart (Sampled Data)',
    carrier_historical_line_chart: 'Sesnor Point Historical Line Chart',
    monitoring_point_mode_must_be_selected: 'Should be in the Asset Mode.',
    label_carrier_name: 'Asset Details',
    label_carrier_status: 'Asset Status',
    registy: 'Sign Up',
    company_name: 'Company Name',
    company_id: 'Company ID',
    mobile: 'Mobile',
    registy_checkbox_tip: 'By checking this box, you agree to our ',
    terms_and_conditions: 'User Agreement',
    privacy_policy: 'Privacy Policy',
    and: 'and',
    pwd_tips1: 'Invalid password. Use letters, numbers, or special characters (6–30 chars).',
    registy_checkbox_tip2: 'Please check the agreement.',
    visit_system_now: 'No, I would like to visit system now.',
    let_go: "Yes, let's go",
    Registry_complete_tips: 'Registration completed. Continue device registration?',
    Registering: 'Registering...',
    device_tips: 'Device registered. Please activate the device.',
    device_enrollment: 'Device Registration',
    nothing: 'Nothing to do',
    set_the_devices_now: "Now, let's set up the device.",
    coz: 'Carbon Dioxide(CO₂)',
    coz_net_tips: 'Carbon dioxide type cannot be batch-modified with other types for reporting rules. Please reselect.',
    no_device_tips: 'No devices found. Please contact the administrator.',
    browser: 'Browser',
    unit_path: 'Unit Path',
    add_department: 'New Department',
    please_add_a_department: 'Please add child nodes first.',
    please_add_plan_image: 'Please upload the floor plan first.',
    organizational_no_plan: 'No floor plan available for the current organizational unit. Please select one with a floor plan.',
    organizational_no_map: 'The current organizational unit has no map location. Please position it first.',
    custom_monitoring: 'Custom Monitoring',
    add_custom_monitoring: 'Custom Monitoring',
    select_device: 'Select Device',
    cannot_add_child_nodes: 'This organization cannot add child nodes. Please choose another one.',
    same_node_exists: 'The same node already exists',
    please_select_unit_path: 'Please select the unit path.',
    map: 'Map',
    device_select_tips: 'The device has already been associated to a sensor point. After submission, the device will be forced to associate to a new asset',
    custom_device: 'Custom Monitoring Devices',
    device_plan_location_tips: 'The device has been associated  to other floor plans. Are you sure to switch association?',
    delete_anchor_points:'Delete Marker',
    no_map_added:'This node is not in the map. Add it?',
    no_plan_added:'This node has no floor plan yet. Add one?',
    speed_grade_1:"Normal Speed",
    speed_grade_2:"Fast",
    speed_grade_3:"Fast+",
    speed_grade_4:"Fash++",
    speed_grade_5:"Fastest",
    auto_configuration:"Auto Configuration",
    please_select_lpwan_mode:"Please select the LPWANMode.",
    pan_id_cannot_be_empty:"PANID is required.",
    join_attemp_cannot_be_empty:"Join Attemp is required.",
    panid_format_is_hexadecimal: 'The PANID is four bytes in hexadecimal.',
    ext_pan_id_cannot_be_empty:"ExtPANID is required.",
    please_select_explain:"Please select the explain ",
    are_you_sure_you_want_to_delete_group: 'Please confirm to delete this group.',
    are_you_sure_you_want_to_delete_guide_item: 'Confirm deletion of this guide item?',
    are_you_sure_you_want_to_modif_status_guide_item: 'Confirm deletion of this guide item?',
    please_enter_at_command:"Please enter AT commands, separated by semicolons (;).",
    positioning_mode:"Positioning Mode",
    please_select_address:"Please enter the address",
    please_select_longitude:"Please select the longitude",
    please_select_latitude:"Please select the latitude",
    associated_device: 'Associated Device',
    disassociated_device: 'Disassociate',
    realTime_status_detectio_device:'Device Real-time Status',
    picture:'Picture',
    are_you_sure_you_want_to_delete_picture: 'Please confirm to delete this picture.',
    upload_picture:'Upload Picture',

    // Invalid Rule 专用 keys
    ir_carrier: 'Asset',
    ir_installation_point: 'Location',
    ir_carrier_type: 'Asset Type',
    ir_type: 'Type',
    ir_close: 'Close or Not',
    ir_close_header: 'Closed',
    ir_abnormal_time: 'Happen Time',
    ir_belonging_to: 'Organization',
    ir_processing_results: 'Cause',
    ir_processing_records: 'Handled Records',
    ir_abnormal_record: 'Event Records',
    ir_application: 'OK',
    ir_cancel: 'Cancel',
    ir_time: 'Time',
    ir_causes: 'Cause',
    ir_process_time: 'Handled Time',
    ir_status: 'Status',
    log: 'Log',

    // 设备状态级联提示
    device_hint_pending: 'Device recorded. Awaiting first data report. Auto-transitions to "Unbound" upon validation.',
    device_hint_unbound: 'Device validated but not yet linked to an asset (location). Binding is required to enable business operations.',
    device_hint_bound: 'Device successfully linked to asset. Fully operational — monitoring, anomaly detection, and alerting are active.',
    device_hint_inactive: 'Device manually deactivated. No active monitoring during this period, but historical data is preserved. Can be re-enabled anytime.',
    // Base strategy / association mode
    use_latest_device_data: 'Use Latest Device Data',
    force_use_latest_bound_device_data: 'Force Use Latest Bound Device Data',
    custom_processing_strategy: 'Custom Processing Strategy',
    force_replacement: 'Force Replacement',
    prompt_duplicate: 'Prompt Duplicate',
  },
  asset: {
    mode: {
      normal_mode: 'Normal Mode',
      transportation_mode: 'Transportation Mode'
    }
  },
  // ===== Account Redesign (feat-jri/account-redesign) =====
  accountRedesign: {
    // Login Tabs
    tab_personal: 'Personal',
    tab_enterprise: 'Enterprise',
    // Login Form
    label_company_id: 'Company ID',
    placeholder_company_id: 'Please enter Company ID',
    placeholder_username_or_email: 'Account / Email',
    placeholder_password: 'Password',
    placeholder_captcha: 'Captcha',
    // Root login switch
    root_login_link: 'Root Login (No Company ID required)',
    back_to_enterprise_login: 'Back to Enterprise Login',
    btn_root_login: 'Root Login',
    btn_switch_to_root: 'Login as Prime',
    btn_switch_to_enterprise: 'Login as Identity',
    // Register
    register_title: 'Create Account',
    register_type_personal: 'Personal Register',
    register_type_personal_desc: 'For personal use, no company info needed',
    register_type_enterprise: 'Enterprise Register',
    register_type_enterprise_desc: 'Requires Company ID to join an existing enterprise',
    badge_free: 'Free',
    badge_need_company_id: 'Need Company ID',
    // Register Form
    label_username: 'Username',
    placeholder_username: 'Username (login account)',
    label_display_name: 'Display Name',
    placeholder_display_name: 'Display name',
    label_email: 'Email',
    placeholder_email: 'Please enter email',
    label_mobile: 'Mobile',
    placeholder_mobile: 'Please enter mobile number',
    label_password: 'Password',
    placeholder_password_register: 'Password (8-30 chars, with upper/lower/digit/symbol)',
    label_confirm_password: 'Confirm Password',
    placeholder_confirm_password: 'Please enter password again',
    label_captcha: 'Captcha',
    // Enterprise register steps
    step_verify_company: 'Verify Company ID',
    step_userInfo: 'User Information',
    btn_verify: 'Verify',
    btn_verifying: 'Verifying...',
    btn_verified: 'Verified',
    company_verified_tip: 'Verified: {name}',
    apply_company_link: "Don't have a Company ID? Apply now",
    // Apply Company ID
    apply_company_title: 'Apply for Company ID',
    label_company_name: 'Company',
    placeholder_company_name: 'Please enter company name',
    label_contact_name: 'Contact Name',
    placeholder_contact_name: 'Please enter contact name',
    label_contact_mobile: 'Mobile/Phone',
    placeholder_contact_mobile: 'Please enter mobile/phone',
    label_contact_email: 'Email',
    placeholder_contact_email: 'Please enter email',
    label_description: 'Description',
    placeholder_description: 'Please enter description (optional)',
    apply_submitted_tip: 'Application submitted. You will be notified by email after approval',
    // Forget / Reset / Force-change password
    forget_password_title: 'Forgot Password',
    forget_password_tip: 'Please enter your registered email. A reset link will be sent to it.',
    btn_send_reset_link: 'Send Reset Link',
    reset_password_title: 'Reset Password',
    label_new_password: 'New Password',
    placeholder_new_password: 'Please enter new password',
    label_confirm_new_password: 'Confirm New Password',
    placeholder_confirm_new_password: 'Please enter new password again',
    btn_reset_password: 'Reset Password',
    force_change_password_title: 'First Login Password Change',
    force_change_password_tip: 'First login detected. Please change your initial password to continue.',
    label_old_password: 'Old Password',
    placeholder_old_password: 'Please enter old password',
    btn_force_change: 'Confirm',
    // Common buttons / links
    btn_login: 'Sign In',
    btn_register: 'Register',
    btn_cancel: 'Cancel',
    btn_confirm: 'Confirm',
    btn_ok: 'Ok',
    btn_close: 'Close',
    link_forget_password: 'Forgot Password',
    link_register: 'Sign Up',
    link_back_to_login: 'Already have an account? Sign in',
    link_have_account_signin: 'Already have an account? Sign In',
    agree_policy_tip: 'I have read and agree to',
    policy_terms: 'Terms of Service',
    policy_privacy: 'Privacy Policy',
    policy_and: 'and',
    // Error messages
    err_account_frozen: 'Account has been frozen',
    err_account_disabled: 'Account has been disabled',
    err_user_type_mismatch: 'User type does not match the login mode',
    err_company_code_not_exist: 'Company ID does not exist',
    err_company_code_already_applied: 'This Company ID application has already been submitted',
    err_company_apply_not_found: 'Application not found',
    err_company_apply_already_processed: 'Application has already been processed',
    err_password_policy: 'Password must be at least 8 characters with uppercase, lowercase, digits and symbols',
    err_invitation_expired: 'Invitation has expired. Please contact your administrator',
    err_first_login_change_required: 'First login requires password change',
    err_password_not_match: 'The two passwords do not match',
    err_captcha_incorrect: 'Incorrect captcha',
    err_agree_policy_required: 'Please read and agree to the Terms and Privacy Policy first',
    // Success messages
    success_register_personal: 'Personal registration successful! Please login',
    success_register_enterprise: 'Enterprise registration successful! Please login',
    success_apply_submitted: 'Application submitted, please wait for review',
    success_send_reset_link: 'Reset link has been sent to your email',
    success_reset_password: 'Password reset successful! Please login',
    success_force_change: 'Password changed, please login again',
    force_change_failed: 'Password change failed, please try again',
    success_login_personal: 'Login Success!',
    success_login_enterprise: 'Login Success!',
    success_login_root: 'Login Success!',
    login_failed: 'Account or password incorrect'
  }
}
